import styled from "styled-components";
import React from "react";
import { InfoCircle } from "../../assets/Podcast/InfoCircle";
import { DocumentCopy } from "../../assets/Podcast/DocumentCopy";
import { Refresh } from "../../assets/Podcast/Refresh";
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import { LoadingWLogo } from "../../components/LoadingWLogo";
import { TextBtn } from "../../components/inputs/TextBtn";

const StyleCss = styled.div`
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 15px));
  grid-gap: 20px;
  --fs-title: 24px;
  .bg-dash {
    background-color: #fff;
    border-radius: 8px;
    padding: 0.5rem;
  }
  .shadow-dash {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  .title {
    grid-column: 1/5;
    padding: 1rem;
    border-radius: 16px 16px 0 0;
    font-size: var(--fs-title);
    font-weight: 500;
  }
  .loc-1 {
    grid-column: 1/5;
  }
  .loc-2 {
    grid-column: 1/3;
    grid-row: 3/4;
  }
  .helper {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    .text {
      flex-grow: 1;
      font-size: 14px;
      font-weight: 500;
    }
    .icon {
      width: 64px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 48px;
        height: 48px;
        display: block;
        /* fill: #236BF6; */
        fill: var(--o-prime-1);
        &.red {
          fill: red;
        }
      }
    }
    .actions {
      margin: 0 1rem;
    }
  }
  .feed {
    grid-column: 3/5;
    grid-row: 2/4;
    padding: 1rem 1rem;
    .title-feed {
      font-size: 16px;
      font-weight: 500;
      margin: 0.5rem;
    }
    .desc {
      font-size: 14px;
      font-weight: normal;
      margin: 0 0.5rem;
    }
    .options {
      margin: 0.5rem 0 0;
      display: flex;
      flex-direction: row-reverse;
      flex-wrap: wrap;
      .feed-link {
        background-color: var(--n-grey-3);
        color: var(--n-grey-8);
        padding: 0.5rem 0.5rem 0.3rem;
        flex-grow: 1;
        text-align: left;
        direction: ltr;
        margin: 0.5rem;
        border-radius: 4px;
        display: flex;
        align-items: center;
      }
      .btn {
        padding: 0.5rem;
        background-color: var(--n-grey-1);
        margin: 0.5rem;
        border: 1px solid var(--n-grey-3);
        border-radius: 4px;
        svg {
          stroke: var(--n-grey-7);
          display: block;
        }
      }
    }
  }
  .pod-msg {
    grid-column: 1/5;
  }
`;

export const Dashboard_Query = gql`
  query DashboardQuery{
    getDashboardData {
      basicData
      resumeData
      documentData
    }
  }
`

function WorkPageDashboard(props) {
  const dashboard = useQuery(Dashboard_Query, {
    fetchPolicy: "network-only"
  });
  if(dashboard.loading){
    return (
      <StyleCss>
        <div className="title bg-dash">
          Welcome to farazandishan panel
        </div>
        <div className="content">
          <LoadingWLogo/>
        </div>
      </StyleCss>
    )
  }
  const makeUserData = () => {
    const basicData = (dashboard.data.getDashboardData) ? dashboard.data.getDashboardData.basicData : false;
    if(basicData){
      return (
        <div className="helper loc-1 bg-dash shadow-dash">
          <div className="icon"><InfoCircle/></div>
          <div className="text">personal information filled</div>
          <div className="actions">
            <TextBtn
              link={"/work/personal-data/edit?return=/work/dashboard"}
              text={"Edit Personal Info"}
            />
          </div>
        </div>
      )
    }
    return (
      <div className="helper loc-1 bg-dash shadow-dash">
        <div className="icon"><InfoCircle className={"red"}/></div>
        <div className="text">please fill your personal information </div>
        <div className="actions">
          <TextBtn
            link={"/work/personal-data/edit?return=/work/dashboard"}
            text={"Fill Personal Info"}
          />
        </div>
      </div>
    )
  }
  const makeResumeData = () => {
    const basicData = (dashboard.data.getDashboardData) ? dashboard.data.getDashboardData.resumeData : false;
    if(basicData){
      return (
        <div className="helper loc-1 bg-dash shadow-dash">
          <div className="icon"><InfoCircle/></div>
          <div className="text">Resume filled</div>
          <div className="actions">
            <TextBtn
                link={"/work/resume/edit?return=/work/dashboard"}
                text={"Edit Your Resume"}
            />
          </div>
        </div>
      )
    }
    return (
      <div className="helper loc-1 bg-dash shadow-dash">
        <div className="icon"><InfoCircle className={"red"}/></div>
        <div className="text">fill out resumeData</div>
        <div className="actions">
          <TextBtn
              link={"/work/resume/edit?return=/work/dashboard"}
              text={"Fill Your Resume"}
          />
        </div>
      </div>
    )
  }
  const makeDocumentData = () => {
    const basicData = (dashboard.data.getDashboardData) ? dashboard.data.getDashboardData.documentData : false;
    if(basicData){
      return (
        <div className="helper loc-1 bg-dash shadow-dash">
          <div className="icon"><InfoCircle/></div>
          <div className="text">National ID and Paper sent</div>
          <div className="actions">
            <TextBtn
                link={"/work/documents?return=/work/dashboard"}
                text={"Send Your Documents"}
            />
          </div>
        </div>
      )
    }
    return (
      <div className="helper loc-1 bg-dash shadow-dash">
        <div className="icon"><InfoCircle className={"red"}/></div>
        <div className="text">Send National ID and Paper</div>
        <div className="actions">
          <TextBtn
              link={"/work/documents?return=/work/dashboard"}
              text={"Send Your Documents"}
          />
        </div>
      </div>
    )
  }
  return (
    <StyleCss>
      <div className="title bg-dash shadow-dash">
        Welcome to farazandishan panel
      </div>
        {makeUserData()}
        {makeResumeData()}
        {makeDocumentData()}
       {/* <div className="helper loc-1 bg-dash shadow-dash">
        <div className="icon"><InfoCircle/></div>
        <div className="text">Ruls</div>
      </div>
      <div className="helper loc-2 bg-dash shadow-dash">
        <div className="icon"><InfoCircle/></div>
        <div className="text">Info</div>
      </div> */}
      {/* {makeFeedData()} */}
    </StyleCss>
);
}
export default WorkPageDashboard;